import React, { lazy, Suspense, useState, useEffect } from 'react';
import useComponentBuilder from '../utils/useComponentBuilder';
import TransmitConstants from '../constants';
export default function AuthFlowComponent(props) {
  window.authInvokeResult = {};
  window.path = "";
  const [currentAuth, setCurrentAuth] = useState({
    index: 0,
    nextStep: null,
    previousAuthResponse: {}
  });
  const auth = useComponentBuilder(currentAuth.index, currentAuth.nextStep, props.list);
  const path = auth.component;
  window.path = path;
  // eslint-disable-next-line
  const AuthComponent = /*#__PURE__*/lazy(() => import( /*webpackChunkName:'base'*/ /* webpackPrefetch: true */`../baseComponents/${path}`));
  let isPrimarySessionActive = props.transmitsdk?.currentSession;
  const handleCurrentSession = () => {
    if (props.transmitsdk?.currentSession) {
      isPrimarySessionActive = true;
    } else {
      const errorResponse = {
        status: {
          response_code: TransmitConstants.policyResponse.systemError,
          response_desc: TransmitConstants.responseDesc.systemError,
          trans_id: props.params.header.trans_id
        },
        authentication_status: TransmitConstants.authenticationStatus.systemError,
        token: ""
      };
      props.handleAuthResponse(errorResponse);
    }
  };
  const handleAuthResponse = response => {
    if ('next_step' in response) {
      if (response.next_step != "" || null) {
        const step = response.next_step;
        const nextIndex = currentAuth.index + 1;
        if (response.next_step != '' || null) {
          handleCurrentSession();
          setCurrentAuth({
            index: nextIndex,
            nextStep: step,
            previousAuthResponse: response
          });
        } else {
          props.handleAuthResponse(response);
          return false;
        }
      } else {
        props.handleAuthResponse(response);
        return false;
      }
    }
  };
  useEffect(() => {
    const abortController = new AbortController();
    return function cancel() {
      abortController.abort();
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(AuthComponent, {
    params: props.params,
    appData: props.appData,
    handleAuthResponse: handleAuthResponse,
    analytics: props.analytics,
    formatResponse: props.formatResponse,
    transmitsdk: props.transmitsdk,
    transmitui: props.transmitui,
    isPrimarySessionActive: isPrimarySessionActive,
    hasAnalytics: props.hasAnalytics,
    theme: props.theme,
    config: props.config,
    response: currentAuth['previousAuthResponse'],
    isLoggingEnabled: props.isLoggingEnabled,
    list: props.list,
    isQueueService: props.isQueueService,
    currentAuth: currentAuth,
    xmHandler: props.xmHandler,
    isVoiceEnabled: props.isVoiceEnabled
  })));
}